module.exports = __webpack_public_path__ + "img/instagram.4792c111.svg";